module.exports = __webpack_public_path__ + "static/media/1.6da8c5f8.JPG";